module.exports = __webpack_public_path__ + "87eb7d6f.svg";